import { modeToLabel } from "@/lib/verdict-format";

type Props = { saisineNumber: string; mode?: string };

export function VerdictBandeau({ saisineNumber, mode }: Props) {
  const modeLabel = mode ? modeToLabel(mode) : null;
  const cells = [
    "Conseil Hōjin",
    modeLabel ? `Mode · ${modeLabel}` : "Le Conseil",
    `N° ${saisineNumber}`,
  ];
  return (
    <div
      data-testid="verdict-bandeau"
      data-rp="verdict-bandeau"
      style={{
        borderTop: "0.5px solid var(--qv3-grey-100)",
        borderBottom: "0.5px solid var(--qv3-grey-100)",
        padding: "10px 0",
        marginBottom: 56,
        display: "flex",
        gap: 16,
      }}
    >
      {cells.map((c, i) => (
        <div
          key={i}
          data-testid={i === 1 ? "verdict-mode" : undefined}
          style={{
            flex: 1,
            textAlign: i === 0 ? "left" : i === 1 ? "center" : "right",
            fontFamily: "var(--qv3-font-mono)",
            fontSize: 10,
            color: "var(--qv3-gold)",
            letterSpacing: 3,
            textTransform: "uppercase",
          }}
        >
          {c}
        </div>
      ))}
    </div>
  );
}

export default VerdictBandeau;
